import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import Typography from "@mui/material/Typography"
import { Client } from "../../../utils/types";

type ContractCardProps = {
  selectedClient: Client;
}

export const ContractCard = (props: ContractCardProps) => {

  const { selectedClient } = props;

  return(
    <Card
      sx={{
        p: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 48,
      }}
    >
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Contract (WIP)
      </Typography>
      <Box
        sx={{
          flex: 1,
          minHeight: 200,
          borderRadius: 1,
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "auto",
        }}
      >
        {selectedClient?.contractUrl ? (
          <iframe
            src={selectedClient.contractUrl}
            title="Client Contract"
            width="100%"
            height="100%"
            style={{ border: "none", minHeight: 180 }}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            No contract uploaded.
          </Typography>
        )}
      </Box>
    </Card>
  )
}